import React, { useEffect, useMemo, useState } from 'react'
import TransaksiService from '../../../services/transaksi/TransaksiService'
import { Offcanvas, Spinner } from 'react-bootstrap'
import DataTable from 'react-data-table-component'

const ModalLogRollback = ({ showLogRollback, handleCloseLogRollback, datappm }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [listRollback, setListRollback] = useState([])
    const [loading, setLoading] = useState(false)

    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAju']
        },
        {
            name: 'Alasan Dikembalikan',
            cell: row => row['alasanRollback']
        }
    ]

    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true)
            try {
                const _resRollback = await transaksiService.listHistoryRollback(datappm.nomorAju)
                setListRollback(_resRollback.data.data)
            } catch (error) {

            }
            setLoading(false)
        }
        fetchAllData()
    }, [transaksiService, datappm])
    return (
        <>
            <Offcanvas
                show={showLogRollback}
                onHide={handleCloseLogRollback}
                placement='bottom'
                scroll={true}
            >
                <Offcanvas.Header closeButton>
                    <div className="d-flex align-items-center">
                        <h5>
                            Log Rollback Permohonan
                        </h5>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="table-responsive border-bottom my-3">
                        {(loading && <Spinner />)}
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columns}
                            data={listRollback}
                            highlightOnHover
                            pagination
                        />
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default ModalLogRollback